import "bootstrap-icons/font/bootstrap-icons.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import AppState from "./app/contextState/state";
// import { registerServiceWorker } from './serviceWorker'

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import App from "./App";
import { store } from "./app/store";
import Alert from "./features/alert/Alert";
import { AuditState } from "./hooks/auditContext";
import { ChecklistState } from "./hooks/checklistContext";
import { PoliciesState } from "./hooks/policiesContext";
import { AgreementState } from "./hooks/agreementContext";
import { RiskAssesmentState } from "./hooks/riskAssesmentContext";
import { ShareState } from "./hooks/shareContext";
import { FormState } from "./hooks/formContext";
const container = document.getElementById("root");
const root = createRoot(container);

const stripePromise = loadStripe(process.env.REACT_APP_ENV == 'dev' ? process.env.REACT_APP_STRIPE_KEY_DEV : process.env.REACT_APP_STRIPE_KEY);
// const stripePromise = loadStripe("pk_test_51PonuY05tvmvcgMHEGnkDaDRL7355LXayKH2ICvCna6HXSQDt0VCMR7YR5umI1YFzg1sb6f3dVuBwApX15qRsJpA007V4H1kHp");
root.render(
  // <React.StrictMode>
  <Elements stripe={stripePromise}>
    <Provider store={store}>
      <BrowserRouter>
        <AppState>
          <FormState>
          <AuditState>
            <RiskAssesmentState>
              <ChecklistState>
                <PoliciesState>
                  <ShareState>
                    <AgreementState>
                      <DndProvider backend={HTML5Backend}>
                        {/* <PersistGate loading={null} persistor={persistor}> */}
                        <App />
                        <Alert />
                        {/* </PersistGate> */}
                      </DndProvider>
                    </AgreementState>
                  </ShareState>
                </PoliciesState>
              </ChecklistState>
            </RiskAssesmentState>
          </AuditState>
          </FormState>
        </AppState>
      </BrowserRouter>
    </Provider>
  </Elements>
  // </React.StrictMode>
);
